import { Phone } from "lucide-react";
import { SITE } from "@/data/site";

/**
 * Bandeau flottant "APPEL URGENCE" — sticky bottom sur mobile uniquement.
 * Objectif : maximiser la conversion d'un trafic d'urgence (personne bloquée dehors).
 * Masqué en desktop (>= lg) où le CTA est déjà visible dans le header.
 */
export default function MobileUrgencyBar() {
  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 border-t"
      style={{
        background: "var(--navy-deep)",
        borderColor: "var(--orange)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="mobile-urgency-bar"
    >
      <a
        href={SITE.telephoneHref}
        className="flex items-center justify-center gap-3 py-4 px-5 font-heading font-extrabold uppercase tracking-wider"
        style={{ color: "var(--white)" }}
        data-testid="mobile-urgency-cta"
      >
        <span className="pulse-dot" aria-hidden="true"></span>
        <Phone size={22} strokeWidth={2.5} style={{ color: "var(--orange)" }} />
        <span>Appel urgence</span>
        <span className="font-mono text-sm" style={{ color: "var(--brass-light)" }}>
          {SITE.telephone}
        </span>
      </a>
    </div>
  );
}
